import { useMutation, useQueryClient } from '@tanstack/react-query';
import { OtherSettings } from '../../domain/otherSettings';
import { useAuthentication } from '../../modules/auth/AuthenticationProvider';
import { BACKEND_URL } from '../backend-url';

export const useChangeOtherSettingsRepository = () => {
    const { getJwtToken } = useAuthentication();
    const queryClient = useQueryClient();

    const changeOtherSettings = useMutation({
        mutationFn: (newOtherSettings: OtherSettings) => changeOtherSettingsFunction(newOtherSettings),
        onSuccess: async () => {
            await queryClient.invalidateQueries({ queryKey: ['companySettings'] });
        }
    });

    const changeOtherSettingsFunction = async (newOtherSettings: OtherSettings) => {
        const token = await getJwtToken();

        await fetch(`${BACKEND_URL}/settings`, {
            method: 'PATCH',
            body: JSON.stringify({
                otherSettings: newOtherSettings,
            }),
            headers: {
                Authorization: `Bearer ${token}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
        });
    };

    return {
        changeOtherSettings: (newOtherSettings: OtherSettings) => changeOtherSettings.mutateAsync(newOtherSettings),
    };
};
